<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { pushGAEvent } from "@/analyticsHelper";

import { ref, watch } from "vue";

const isOpen = ref(false);

watch(isOpen, (newValue) => {
    document.body.style.overflow = newValue ? "hidden" : "";
});
</script>
<template>
    <div class="top-0 sticky z-50">
        <Disclosure
            v-slot="{ open }"
            as="nav"
            class="w-full bg-white text-black shadow-top-animation border-b border-gray"
        >
            <div class="container">
                <div class="mx-auto w-full xl:w-10/12">
                    <div class="flex h-auto items-center p-5 md:px-3 xl:px-0">
                        <div class="flex w-full items-center justify-between">
                            <div class="flex-shrink-0">
                                <slot name="logo" />
                            </div>
                            <div class="hidden lg:ml-6 lg:block">
                                <ul class="flex items-center space-x-2">
                                    <slot name="desktop-menu" />
                                </ul>
                            </div>
                        </div>
                        <div class="-mr-2 flex lg:hidden">
                            <DisclosureButton
                                class="inline-flex items-center justify-center p-2 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange"
                                @click="isOpen = !isOpen"
                            >
                                <i v-if="!open" class="fa-regular fa-bars text-2xl text-black"></i>
                                <i v-else class="fa-regular fa-xmark text-2xl text-black"></i>
                            </DisclosureButton>
                        </div>
                    </div>
                </div>
            </div>

            <DisclosurePanel class="h-screen lg:hidden">
                <ul>
                    <slot name="mobile-menu" />
                </ul>
            </DisclosurePanel>
        </Disclosure>
    </div>
</template>
